/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
export * as operations from './operations';
export * from './data-contracts';
/** Version of the API specification */
export const specVersionHash = "37c6bb7ed5a0c03f0362da99b825585bc97bb2273c23574ef351e2042afcc94d";